import React, { useState, useEffect } from "react"
import {
  PrimaryItem,
  Clickables,
  SecondaryList,
  SecondaryItem,
  NavItemButton,
  ThirdItem,
  ThirdList,
} from "./style"
import { Icon } from "helpers/getIcon"
import { Link } from "gatsby"

const InternalNavItem = ({
  label,
  link,
  nestedItems,
  id,
  itemClicked,
  setItemClicked,
  nestedItemsLink,
}) => {
  const [expanded, setExpanded] = useState(itemClicked === id)

  const icon = <Icon name="arrow-right" />

  const handleClick = () => {
    setExpanded(!expanded)
    if (setItemClicked) {
      setItemClicked(id)
    }
  }

  useEffect(() => {
    if (itemClicked !== id) {
      setExpanded(false)
    }
  }, [itemClicked])

  console.log(nestedItems)

  return (
    <PrimaryItem>
      <Clickables expanded={expanded}>
        {nestedItems?.nodes.length > 0 ? (
          <NavItemButton
            onClick={() => {
              handleClick()
            }}
            label={label}
            expanded={expanded}
            icon={icon}
          ></NavItemButton>
        ) : (
          <NavItemButton
            link={link}
            label={label}
            expanded={expanded}
          ></NavItemButton>
        )}
      </Clickables>

      {nestedItems?.nodes.length > 0 && (
        <SecondaryList expanded={expanded}>
          <SecondaryItem>
            <Link to={link}>
              <span>Overview</span>
            </Link>
          </SecondaryItem>
          {nestedItems.nodes.map((child, index) => {
            return (
              <div key={index}>
                <SecondaryItem>
                  <Link activeClassName="active" to={child.link}>
                    <span dangerouslySetInnerHTML={{ __html: child.title }} />
                  </Link>
                </SecondaryItem>
                <ThirdList expanded={expanded}>
                  {child?.childPages?.nodes?.map((grandChild, index) => {
                    return (
                      <ThirdItem key={index}>
                        <Link activeClassName="active" to={grandChild.link}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: grandChild.title,
                            }}
                          />
                        </Link>
                      </ThirdItem>
                    )
                  })}
                </ThirdList>
              </div>
            )
          })}
        </SecondaryList>
      )}
    </PrimaryItem>
  )
}

export default InternalNavItem
